var path = '/components/components/contact-picklists/contact-picklists.tpl.html';
var html = "<div class=\"booking-details\"><h3>\n    Picklists\n</h3>\n    <div class=\"details-wrapper\">\n    <span ng-repeat=\"picklist in vm.picklists\"><a\n            ui-sref=\"app.picklists.contacts.index({pid: picklist.id, back: vm.back,backParams: vm.backParams})\">{{picklist.name}}</a><span\n            ng-if=\"!$last\">&nbsp;&nbsp;|&nbsp;&nbsp;</span></span>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/contact-picklists/contact-picklists.tpl.html
// module id = 1966
// module chunks = 1